import React, {
    useEffect, useContext, useState, useCallback
} from 'react';
import { useLocation } from 'react-router-dom';
//import { renderContentFromMetadata } from '@jutro/uiconfig';
import { MetadataContent } from '@jutro/uiconfig';
import { TranslatorContext, IntlContext } from '@jutro/locale';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { generateURL } from 'gw-portals-url-js';
import { PolicyService } from 'gw-capability-policy';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { useAuthentication } from 'gw-digital-auth-react';
import metadata from './PayrollFrame.metadata.json5';
import styles from './PayrollFrame.module.scss';
import { Icon } from '@jutro/components';
//import cookie from 'js-cookie';
import { DateUtil } from 'gw-portals-util-js' // FB 21686

function PayrollFrame(props) {
    const translator = useContext(TranslatorContext);
    const { authHeader } = useAuthentication();
    const [policyResponse, setPolicyResponse] = useState([]);
    const [currentPolicy, setCurretPolicy] = useState('');    
    const [auditNumber, setAuditNumber] = useState();
    const [serviceLocNum, setServiceLocNum] = useState('1');
    const [isLoading, setLoadingState] = useState(true);
    const location = useLocation();
    const intl = useContext(IntlContext);
    const auth = useAuthentication();

    useEffect(() => {
        if (!_.isUndefined(location.state) && !_.isEmpty(location.state)) {
            const { policyNumber, auditNumber, serviceLocNum } = location.state; 
            setAuditNumber(auditNumber);
            setCurretPolicy(policyNumber);
            setServiceLocNum(serviceLocNum);
            setLoadingState(false);

        } else {
            setLoadingState(true);
            PolicyService.getAccountPolicySummaries(authHeader).then(
                (getPolicyResponse = {}) => {
                    if (!_.isUndefined(getPolicyResponse)) {
                        let pn =_.get(getPolicyResponse[0].periods, '[0].policyId');
                        setCurretPolicy(pn);
                        setPolicyResponse(getPolicyResponse);
                    } 
                }
            ).finally(() => {
                setLoadingState(false);
            });
        } 
        // console.log(`auditNumber = ${auditNumber}  serviceLocNum = ${serviceLocNum}   policyNumber = ${policyNumber} `)
            // disable re render
            // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);
/*
Open Payroll Reports:
/auditpc/AuditController?l_usrid={userId}&access_type=t1&pn={policyNbr}

General Info Access:
/auditpc/AuditController?l_userId={userId}&access_type=t1&an={auditNbr}&sl={serviceLocNbr}&navto=GENERALINFO&ts={timestamp in form of HHmmss}

*/ 
    const generatePayrollURL = () => {
        const getUrl = window.location;
        const baseUrl = `${getUrl.origin}/auditpc/AuditController`;
        //const baseUrl = `https://ladwpolgpe1.ri-net.com/auditpc/AuditController`;
        const redirectRoute = _.get(appConfig, 'documentNotFoundRedirectUrl') || '';
        const userId = (auth.user_name).replace("policyholder_portal_","");
        //cookie.set('token', authHeader.Authorization.replace("Bearer ", ""));
        let params = {};
        if (!_.isEmpty(auditNumber)) {  
            params = {
                l_usrid: `${userId}`,
                access_type: 't1',
                an: auditNumber,
                sl: serviceLocNum,
                p_m: '1',
                navto: 'GENERALINFO',
                ts: getFormattedTime(),
                pn: currentPolicy // FB 21686
            };    

        } else {
            params = {
                //urlParam: documentID,
                //token,
                l_usrid: `${userId}`,
                access_type: 't1',
                pn: currentPolicy,
                p_m: '1',
                ts: getFormattedTime() // FB 21686
                //portalRoute: `${baseUrl}/auditpc/AuditController?l_userId=${userId}&access_type=t1&pn=${policyNumber}`
            };    
        }
        let iframeUrl = isLoading ? 'javascript:void(0)' : generateURL(baseUrl, params);
        return iframeUrl;
    };    

    /* get HHmmss */
    const getFormattedTime = useCallback(() => {        
        let time = DateUtil.convertTimezone(new Date(), DateUtil.timezone.PT); // FB 21686
        let stringTime=("0" + time.getHours()).slice(-2)   + "" + 
            ("0" + time.getMinutes()).slice(-2) + "" + 
            ("0" + time.getSeconds()).slice(-2);
        return btoa(stringTime);
    }, [intl]);  

    const getPayrollHeader = () => {
        return (
            <>
                <div className={styles.gwTypeWithLOB}>
                    <Icon icon="event_available" className={styles.syncIcon} />
                    <h1 className={styles.gwPageTitle}>Report Payroll</h1>
                </div>
            </>
        );
    };

    const overrides = {
        iframePayroll : {
            src : generatePayrollURL(),
            visible: isLoading === false,       
        },
        tabPayrollTitle: {
            content: getPayrollHeader()
        },          
     };
    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {

        },
        resolveComponentMap: {
        }
    };

    //return renderContentFromMetadata(metadata.pageContent, overrides, resolvers);
    return (
        <MetadataContent
            uiProps={metadata.pageContent}
            overrideProps={overrides}
            {...resolvers}
        />
    );    
};

PayrollFrame.propTypes = {
    location: PropTypes.shape({
        search: PropTypes.string,
        state: PropTypes.string
    }),
    history: PropTypes.shape({
        push: PropTypes.func
    })
};

// PayrollFrame.defaultProps = {
//     id: undefined
// };

export default PayrollFrame;
